module.exports = __webpack_public_path__ + "static/media/tobiiDemo_1.f468e155.jpg";